import { createSlice } from "@reduxjs/toolkit";
import { fetchFromStorage, removeFromStorage, saveToStorage } from "../../storage";

interface SelectedVenuesState {
  selectedVenuesForCosting: any;
  selectedVenuesForNewBooking: any;
}
const costingSlice = createSlice({
  name: "costingSlice",
  initialState: {
    selectedVenuesForCosting: JSON.parse(
      fetchFromStorage("selectedVenuesForCosting", true) as string) || [],
    selectedVenuesForNewBooking: JSON.parse(
      fetchFromStorage("selectedVenuesForNewBooking", true) as string) || [],
  },
  reducers: {
    setSelectedVenuesForCosting(state, action) {
      state.selectedVenuesForCosting = action.payload;
      saveToStorage('selectedVenuesForCosting', JSON.stringify(action.payload), true);
    },
    setSelectedVenuesForNewBooking(state, action) {
      state.selectedVenuesForNewBooking = action.payload;
      saveToStorage('selectedVenuesForNewBooking', JSON.stringify(action.payload), true);
    },
    setCostingSliceInitState(state, action) {
      state.selectedVenuesForCosting = [];
      removeFromStorage('selectedVenuesForCosting', true);
      state.selectedVenuesForNewBooking = [];
      removeFromStorage('selectedVenuesForNewBooking', true);
    }
  },

});

export default costingSlice.reducer;
export const { setSelectedVenuesForNewBooking, setSelectedVenuesForCosting, setCostingSliceInitState
} = costingSlice.actions;

export const selectedVenuesNewBooking = (state: { costingSlice: SelectedVenuesState }) =>
  state.costingSlice.selectedVenuesForNewBooking;
export const selectedVenuesForCosting = (state: { costingSlice: SelectedVenuesState }) =>
  state.costingSlice.selectedVenuesForCosting;


